import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { getPatientSummary } from "../../_redux/patientService";
import { useRxData, useRxCollection } from "rxdb-hooks";

export const SummaryDetail = () => {
  const { patientId } = useParams();
  const collection = useRxCollection("patients");

  const { user } = useSelector(
    ({ auth }) => ({
      user: auth.user,
    }),
    shallowEqual
  );

  const queryConstructor = (collection) =>
    collection.find().where("pid").equals(patientId);
  const { result } = useRxData("patients", queryConstructor);

  useEffect(() => {
    if (!result.length && collection) {
      getPatientSummary(patientId, user.practice.id).then((response) => {
        const {
          data: {
            response: { data },
          },
        } = response;

        const {
          id: pid,
          FirstName,
          LastName,
          Email,
          Age,
          Gender,
          DOB,
          MRN,
          City,
          State,
          ZipCode,
          Address1,
          Address2,
          phone_home,
        } = data.Patient;
        collection.insert({
          pid,
          FirstName,
          LastName,
          Email,
          Age,
          Gender,
          DOB,
          MRN,
          City,
          State,
          ZipCode,
          Address1,
          Address2,
          phone_home,
        });
      });
    }
  }, [patientId, collection]);
  
  return (
    result &&
    result.length && (
      <div className="flex w-full justify-between p-16">
        <div className="flex-initial">
          <p className="text-base text-left text-black font-medium">
            {result[0].FirstName + " " + result[0].LastName}
          </p>
          <p className="text-base text-left text-gray-900 font-normal">{`${result[0].sex}  ${result[0].DOB} (${result[0].Age})`}</p>
          <p className="text-base text-left text-gray-900 font-normal">
            MRN: {result[0].MRN}
          </p>
        </div>
        <div className="flex-initial">
          <p className="text-base text-left text-black font-medium">Address</p>
          <p className="text-base text-left text-gray-900 font-normal">
            {" "}
            {result[0].Address1 +
              " " +
              result[0].City +
              " " +
              result[0].State +
              " " +
              result[0].ZipCode}
          </p>
        </div>
        <div className="flex-initial ">
          <p className="text-base text-left text-black font-medium">Phone</p>
          <p className="text-base text-left text-gray-900 font-normal">
            {result[0].phone_home}
          </p>
          <p className="text-base text-left text-gray-900 font-normal"></p>
        </div>
        <div className="flex-initial">
          <p className="text-base text-left text-black font-medium">
            Insuranec
          </p>
          <p className="text-base text-left text-gray-900 font-normal">
            Primary: First Choice
          </p>
          <p className="text-base text-left text-gray-900 font-normal">
            Secondary: Athena
          </p>
        </div>
      </div>
    )
  );
};
